import React, { useState } from "react";
import * as style from "./Admin.module.scss";
import { Tabs, Tab } from "@mui/material";
import AdminApproval from "../../Components/Admin/AdminApproval/AdminApproval";
import ArchivedApprovalRequests from "../../Components/Admin/AdminApproval/ArchivedApprovalRequests";

const RoleAssignmentRequests = () => {
  const scssClass = style as any;

  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <div className={scssClass.adminContainer} style={{ overflowY: "auto" }}>
      <div
        className={scssClass.adminHeader}
        style={{ position: "sticky", top: 0 }}
      >
        <p className={scssClass.adminTitle}>Request Approval</p>

        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="standard"
          aria-label="Role Management"
          sx={{
            "& .MuiButtonBase-root": {
              color: "black !important",
              backgroundColor: "white",
            },
            "& .MuiTabs-indicator": {
              color: "black !important",
              backgroundColor: "black !important",
            },
            "& .MuiTabs-root": {
              marginBottom: "0px !important",
            },
          }}
        >
          <Tab
            label="Active"
            sx={{
              padding: "1rem 2rem",
              textTransform: "none",
              fontWeight: selectedTab === 0 ? "bold" : "",
            }}
          />
          <Tab
            label="Archived"
            sx={{
              padding: "1rem 2rem",
              textTransform: "none",
              fontWeight: selectedTab === 1 ? "bold" : "",
            }}
          />
        </Tabs>
      </div>

      <div className={scssClass.tableContainer} style={{ overflowY: "unset" }}>
        {selectedTab === 0 && <AdminApproval />}
      </div>
      {selectedTab === 1 && <ArchivedApprovalRequests />}
      {/* </div> */}
    </div>
  );
};

export default RoleAssignmentRequests;
